module.exports = __webpack_public_path__ + "img/timor-leste.03347072.svg";